<template>
  <div class="chart-radar">
    <Radar v-if="temEmpresaID" :data="chartData" :options="options" />
    <div
      class="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm"
    >
      <div
        v-for="(value, key) in allProps"
        :key="key"
        class="text-white-400 p-3 rounded shadow"
      >
        <strong class="text-green-400">{{ formatKey(key) }}:</strong>
        {{ value }}
      </div>
    </div>
    <div class="button-container flex justify-center mt-6">
      <ButtonPrint />
    </div>
  </div>
</template>

<script>
import ButtonPrint from '@/components/ui/ButtonPrint.vue'
import {
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from 'chart.js'
import { Radar } from 'vue-chartjs'

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
)

export default {
  name: 'ChartsRadar',
  components: { Radar, ButtonPrint },
  props: {
    // principais props usadas no gráfico
    temEmpresaID: Boolean,
    NivelMaturidade: Number,
    OrganizationalControl: Number,
    OrganizationalControlImplemented: Number,
    PhysicalControl: Number,
    PhysicalControlImplemented: Number,
    PeopleControl: Number,
    PeopleControlImplemented: Number,
    TechnologicalControl: Number,
    TechnologicalControlImplemented: Number,

    // todas as outras props (opcional, mas necessário para exibir tudo)
    PhysicalControlNotApplicable: Number,
    PhysicalControlNotImplemented: Number,
    PhysicalControlPartiallyImplemented: Number,
    FunctionalControlTypes: Number,
    OrganizationalControlNotApplicable: Number,
    OrganizationalControlNotImplemented: Number,
    OrganizationalControlPartiallyImplemented: Number,
    PeoplesControlNotApplicable: Number,
    PeopleControlNotImplemented: Number,
    PeopleControlPartiallyImplemented: Number,
    QtdControlesImplementados: Number,
    QtdControlesNaoImplementados: Number,
    QtdControlesParcial: Number,
    TechnologicalControlNotApplicable: Number,
    TechnologicalControlNotImplemented: Number,
    TechnologicalControlPartiallyImplemented: Number,
    totalControles: Number,
    controleImplementado: Number,
    controleParcial: Number,
    controleNaoImplementado: Number,
    controleNaoaplicavel: Number,
  },
  computed: {
    chartData() {
      const labels = ['Organizacional', 'Físico', 'Pessoas', 'Tecnológico']
      const data = [
        this.calculatePercent(
          this.OrganizationalControlImplemented,
          this.OrganizationalControl
        ),
        this.calculatePercent(
          this.PhysicalControlImplemented,
          this.PhysicalControl
        ),
        this.calculatePercent(
          this.PeopleControlImplemented,
          this.PeopleControl
        ),
        this.calculatePercent(
          this.TechnologicalControlImplemented,
          this.TechnologicalControl
        ),
      ]

      return {
        labels,
        datasets: [
          {
            label: 'Implementação de Controles',
            data,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
          },
        ],
      }
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            beginAtZero: true,
            max: 100,
            ticks: {
              stepSize: 20,
              callback: (value) => `${value}%`,
            },
          },
        },
        plugins: {
          legend: {
            position: 'top',
          },
          tooltip: {
            callbacks: {
              label: (context) => `${context.raw}%`,
            },
          },
        },
      }
    },
    allProps() {
      return { ...this.$props }
    },
  },
  methods: {
    calculatePercent(implemented, total) {
      if (!total || total === 0) return 0
      return parseFloat(((implemented / total) * 100).toFixed(2))
    },
    formatKey(key) {
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
    },
  },
}
</script>

<style scoped>
.chart-radar {
  background-color: transparent;
  width: 100%;
  min-height: 300px;
  max-height: 500px;
  position: relative;
}
</style>
